<script setup lang="ts"></script>

<template>
  <div class="privacy-layout">
    <slot />
  </div>
</template>

<style scoped lang="scss">
  .privacy-layout {
    @include flex-container(column, center, center);
    width: 100%;
    height: 100%;
  }
</style>
